import { render, staticRenderFns } from "./UserStockAlert.vue?vue&type=template&id=206d5566"
import script from "./UserStockAlert.vue?vue&type=script&lang=js"
export * from "./UserStockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports